/* Public configuration baked into the web app. Nothing here is a secret. */

/* Google sign-in web client (GCP project virlandai-demo). Overridable at build
   time with REACT_APP_GOOGLE_CLIENT_ID. */
export const GOOGLE_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_CLIENT_ID
  || '200886230843-8ok7ic8qsqsogb77ldfnhpeu6tu4fkv2.apps.googleusercontent.com';
